/**
 * Charge dynamiquement le `core.js` du SDK depuis le même CDN que le loader,
 * puis appelle son `boot()` avec le contexte de démarrage.
 *
 * Le `core.js` est packagé comme un module ESM (cf. tsup.config.ts). Il est
 * importé via `import()` dynamique runtime — pas de chunk webpack/esbuild.
 *
 * En cas d'échec (réseau, intégrité, exception dans le core), on log un
 * warning et on retourne — le site du client reste 100% fonctionnel.
 */

import type { BootstrapContext } from "../shared/types";

interface CoreModule {
  boot: (context: BootstrapContext) => void;
}

export async function loadCore(context: BootstrapContext): Promise<void> {
  const coreUrl = `${context.sdkBaseUrl}/core.js`;

  try {
    // Le `coreUrl` est une variable runtime → esbuild laisse l'`import()` natif,
    // pas de code splitting build-time (loader et core sont des entry points séparés).
    const moduleNs = (await import(/* @vite-ignore */ coreUrl)) as unknown;

    if (!isCoreModule(moduleNs)) {
      // eslint-disable-next-line no-console
      console.warn("[halmya] core module is missing the expected boot() export");
      return;
    }

    moduleNs.boot(context);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn("[halmya] failed to load core:", err);
  }
}

function isCoreModule(value: unknown): value is CoreModule {
  return (
    typeof value === "object" &&
    value !== null &&
    typeof (value as { boot?: unknown }).boot === "function"
  );
}
